module.exports = __webpack_public_path__ + "static/media/whatsapp-icon.6c43765f.svg";